import { render } from "./LevelStage.vue?vue&type=template&id=d487e324&scoped=true"
import script from "./LevelStage.vue?vue&type=script&lang=js"
export * from "./LevelStage.vue?vue&type=script&lang=js"

import "./LevelStage.vue?vue&type=style&index=0&id=d487e324&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d487e324"]])

export default __exports__